<template>
  <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Company</strong> Form
          </div>
          <b-form v-on:submit.prevent="saveForm()">
            
            <b-form-group
              label="Name"
              label-for="name"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="name" type="text"  autocomplete="name" required class="form-control-warning" v-model="company.name"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Year"
              label-for="year"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="year" type="text"  autocomplete="year" required class="form-control-warning" v-model="company.copyright"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Email"
              label-for="horizEmail"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="horizEmail" type="email"  autocomplete="companyname email" required class="form-control-warning" v-model="company.email"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Phone"
              label-for="phone"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="phone" type="text"  autocomplete="company phone" required class="form-control-warning" v-model="company.phone"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Wa"
              label-for="phone"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="wa" type="text"  autocomplete="company wa" required class="form-control-warning" v-model="company.wa"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Address"
              label-for="address_1"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="address_1" type="text"  autocomplete="company address " required class="form-control-warning" v-model="company.address_1"></b-form-input>              
            </b-form-group>
            
            <b-form-group
              label=""
              label-for="address_2"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="address_2" type="text"  autocomplete="company address "  class="form-control-warning" v-model="company.address_2"></b-form-input>              
            </b-form-group>
            
            <b-form-group
              label=""
              label-for="address_3"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="address_3" type="text" autocomplete="company address "  class="form-control-warning" v-model="company.address_3"></b-form-input>              
            </b-form-group>
            
            <b-form-group
              label="Logo"
              label-for="Logo"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-file id="photo" ref="file" placeholder="" autocomplete="photo" class="form-control-warning" @change="onFileChange" accept="image/*"></b-form-file>              
            </b-form-group>
            <div class="form-group">
              <div class="form-row">
                <label id="__BVID__244__BV_label_" for="password" class="col-sm-3 col-form-label"></label>
                <div class="col-sm-9">              
                  <b-progress :value="uploadPercentage" :max="100" show-progress animated  v-if="!image"></b-progress>
                  <img :src="image" class="" style="width:100px"  v-if="image" />
                </div>
              </div>
            </div>

            <b-form-group
              label="Facebook Link"
              label-for="fb_link"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="fb_link" type="text"  autocomplete="fb_link"  class="form-control-warning" v-model="company.fb_link"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Twitter Link"
              label-for="fb_link"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="tw_link" type="text"  autocomplete="tw_link"  class="form-control-warning" v-model="company.tw_link"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Linkedin Link"
              label-for="linkedin_link"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="linkedin_link" type="text"  autocomplete="linkedin_link"  class="form-control-warning" v-model="company.linkedin_link"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Google Link"
              label-for="google_link"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="google_link" type="text"  autocomplete="google_link"  class="form-control-warning" v-model="company.google_link"></b-form-input>              
            </b-form-group>
            
            <b-form-group
              label="Ig Link"
              label-for="ig_link"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="ig_link" type="text"  autocomplete="google_link"  class="form-control-warning" v-model="company.ig_link"></b-form-input>              
            </b-form-group>
            
            <b-form-group
              label="Title"
              label-for="meta_title"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="meta_title" type="text" required autocomplete="meta_title"  class="form-control-warning" v-model="company.meta_title"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Keywords"
              label-for="meta_keywords"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="meta_keywords" type="text" required autocomplete="meta_keywords"  class="form-control-warning" v-model="company.meta_keywords"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Description"
              label-for="meta_description"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="meta_description" type="text" required autocomplete="meta_description"  class="form-control-warning" v-model="company.meta_description"></b-form-input>              
            </b-form-group>
            
            <div slot="footer">
              <div class="form-row">
                <div class="col-sm-3">
                  
                </div>
                <div class="col-sm-9">
                  <b-button type="submit" size="sm" variant="primary" :disabled="isLoading" > Submit</b-button>
                  <b-button type="button" @click="goBack" size="sm" variant="danger" :disabled="isLoading">Back</b-button>
                </div>
              </div>

            </div>
          </b-form>
        </b-card>
      </b-col>
      
      <BlockUI message="loading" v-if="isLoading">
        <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
      </BlockUI>
  </b-row>
</template>

<script>

export default {
  name: 'Company',
  props: {
    caption: {
      type: String,
      default: 'company '
    },
  },
  
  mounted() {
    this.id = 1;
    if(this.id !== undefined){
      this.getData(this.id);
    }
  },
  data: () => {
    return {
      error: false,
      company: {
        email: '',
      },
      image:'',
      file:'',
      uploadPercentage :0,
      msg : '',
      id:'',
      msg_type : '',
      isLoading:false,
    }
    
  },
  methods: {
    getData(id){
      var app = this;
      var url = this.end_point+'company/show/'+id;
      app.isLoading = true;
      axios.get(url, {})
        .then(function (resp) {
        app.isLoading=false;
        if(resp.data.error){
          app.$notify.error(resp.data.msg);
        }else{
          app.company = resp.data.row;
          if(resp.data.row.prev_img){
            //alert(resp.data.row.prev_img);
            app.image = resp.data.row.prev_img;
          }
        }
      })
      .catch(function (resp) {
        app.isLoading=false;
        app.$notify.error(app.setting.msg_con);
        app.error = true;
      });  
    },
    saveForm() {
      var app = this;
      var newDt = app.company;
      var url = this.end_point;

      if(this.id === undefined){
        url += 'company/store/'
      }else{
        url += 'company/update/'+this.id;
      }
      app.isLoading=true;
      axios.post(url, newDt)
      .then(function (resp) {
        
        app.isLoading=false;
        if(resp.data.error){
          app.isLoading=false;
          app.$notify.error(resp.data.msg);
          window.scrollTo(0,0);
        }else{
          app.$notify.success(resp.data.msg);
          window.scrollTo(0,0);
          //app.$router.replace(`/company?msg=${app.msg}&msg_type=${app.msg_type}`);

        }
      })
      .catch(function (resp) {
        app.isLoading=false;
        app.$notify.error(app.setting.msg_con);
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    submitFile(){
      let formData = new FormData();
      formData.append('file', this.file);
      var app  = this;
      app.isLoading=true;
      axios.post( this.end_point+'users/upload',formData,{
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function( progressEvent ) {
          this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
        }.bind(this)
      }).then(function(e){
        
        app.isLoading=false;
        //console.log(e);
        if(e.data.error){
          app.msg = e.data.msg;
          app.msg_type = 'danger';
          return false;
        }
        app.msg='';
        app.company.new_file = e.data.file_path;       
        app.createImage(app.file);
      })
      .catch(function(e){
          app.isLoading=false;
          app.msg = 'upload filed please try again';
          app.msg_type = 'danger';
      });
    },
    onFileChange(e){
      this.image= '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length){      
          return;
      }
      this.file = files[0];
      this.submitFile();
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  }
}
</script>
